import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  output,
} from '@angular/core';
import { SiaRouteData } from '@sia/shared';
import { SiaBaseComponent } from '../sia-base/sia-base.component';
import { SiaGridComponent } from '../sia-grid/sia-grid.component';
import { SiaMatGridComponent } from '../sia-mat-grid/sia-mat-grid.component';

@Component({
  selector: 'sia-grid-with-actions',
  templateUrl: './sia-grid-with-actions.component.html',
  styleUrls: ['./sia-grid-with-actions.component.scss'],
  standalone: true,
  imports: [SiaGridComponent, CommonModule, SiaMatGridComponent],
})
export class SiaGridWithActionsComponent
  extends SiaBaseComponent
  implements OnDestroy
{
  @Input() isMaterialGrid: boolean = false;
  @Input() gridInformations: { componentId: string; guid?: string } | undefined;
  @Input() gridConfId: string = '';
  @Input() gridHeight: number = 0;
  @Input() title: string = '';
  @Input() isPopUp: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() saveGridState: boolean = true;
  @Input() selectedKeys: any;
  @Input() pageData?: SiaRouteData;
  @Input() compactMatGrid: boolean = true;
  @Input() allowViews: boolean = true;
  @Input() fixedRecords?: number;

  selectedRowsData = output<any>();
  selectedKeysChange = output<any>();

  public get gridWithActionsKeys() {
    return this.selectedKeys;
  }
  public set gridWithActionsKeys(value) {
    this.selectedKeys = value;
    this.selectedKeysChange.emit(this.selectedKeys);
  }

  @HostListener('window:unload')
  ngOnDestroy() {
    this.gridInformations = {} as {
      componentId: string;
      guid: string;
    };
    this.gridConfId = '';
    this.gridHeight = 0;
    this.selectedKeys = null;
    super.ngOnDestroy();
  }
}
